/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CenterUserInviteResponseDto } from '../../models/center-user-invite-response-dto';
import { InviteCenterUserDto } from '../../models/invite-center-user-dto';

export interface CenterInviteLogControlllerInviteUser$Params {

/**
 * 센터 ID
 */
  id: string;
      body: InviteCenterUserDto
}

export function centerInviteLogControlllerInviteUser(http: HttpClient, rootUrl: string, params: CenterInviteLogControlllerInviteUser$Params, context?: HttpContext): Observable<StrictHttpResponse<CenterUserInviteResponseDto>> {
  const rb = new RequestBuilder(rootUrl, centerInviteLogControlllerInviteUser.PATH, 'post');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CenterUserInviteResponseDto>;
    })
  );
}

centerInviteLogControlllerInviteUser.PATH = '/api/center-invite-log/{id}/invite';
